import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgOurMissionSolid = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M0 248.5h54v15H0zM458 248.5h54v15h-54zM248.5 458h15v54h-15zM248.5 0h15v54h-15zM311 223.0195l21.7813 34.3907 12.6718-8.0235L311 194.9805l-32.0664 50.6367 12.6719 8.0273zm0 0" />
    <path d="M278.5 146.5v-55h-75v75.5664L140.1445 281.707l13.129 7.254 16.5546-29.957 18.332 15L211 261.543l22.8438 12.461 18.328-15 51.1134 92.496H118.7148l27.3047-49.4102-13.1289-7.2539L101.5742 351.5H86v15h340v-15h-15.871l-56.6485-89.4414-12.672 8.0234 51.5626 81.418h-71.9453L218.5 167.0664V146.5zm-60-40h45v25h-45zm26.2969 139.1602-12.6406 10.3359L211 244.457l-21.1562 11.539-12.6407-10.336L211 184.5079zM405.121 71.1523c-31.1952-25.1992-68.4843-42.164-107.8241-49.0664l-2.5938 14.7735c36.8477 6.4648 71.7696 22.3554 100.9922 45.961zM475.1367 217.2969l14.7774-2.5938c-8.922-50.871-34.875-98.2617-73.0704-133.4414l-10.164 11.0352c35.793 32.961 60.1015 77.3515 68.457 125M105.3203 92.2969l-10.164-11.0352c-38.1954 35.1797-64.1485 82.5703-73.0704 133.4414l14.7774 2.5938c8.3554-47.6485 32.664-92.039 68.457-125M217.2969 36.8594l-2.5938-14.7735c-39.3398 6.9024-76.6289 23.8672-107.8242 49.0664l9.4258 11.668c29.2226-23.6055 64.1445-39.496 100.9922-45.961M406.6797 419.7031l10.164 11.0352c38.1954-35.1797 64.1485-82.5703 73.0704-133.4414l-14.7774-2.5938c-8.3554 47.6485-32.664 92.039-68.457 125M294.7031 475.1406l2.5938 14.7735c39.3398-6.8985 76.625-23.8672 107.8242-49.0625l-9.4258-11.672c-29.2226 23.6056-64.1484 39.4962-100.9922 45.961M36.8633 294.7031l-14.7774 2.5938c8.922 50.871 34.875 98.2617 73.0704 133.4414l10.164-11.0352c-35.793-32.961-60.1015-77.3515-68.457-125M106.879 440.8516c31.1991 25.1953 68.4843 42.164 107.8241 49.0625l2.5938-14.7735c-36.8438-6.461-71.7696-22.3554-100.9922-45.961zm0 0" />
    <path d="M216 321.5h50v15h-50zM186 321.5h15v15h-15zM156 321.5h15v15h-15zm0 0" />
  </svg>
);
export default SvgOurMissionSolid;
